import { render, staticRenderFns } from "./KiraKontratiAlacakForm.vue?vue&type=template&id=c92edcfa"
import script from "./KiraKontratiAlacakForm.vue?vue&type=script&lang=ts"
export * from "./KiraKontratiAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports